module.exports = __webpack_public_path__ + "static/media/chat-temp.d80b0261.svg";